<div class="h-100" [ngClass]="{'container-fluid': !isModal}">
    <div class="card" [ngClass]="{'text-left h-100 px-0 w-100': isModal, 'card-outline card-lightblue': !isModal}">
        <div class="card-header" [ngClass]="{'bg-light': isModal}">
            <h3 class="card-title mb-0">
                <i *ngIf="this.id" class="fas fa-pencil-alt pr-2"></i>
                <i *ngIf="!this.id" class="far fa-file pr-2"></i>
                {{ titulo }}
            </h3>
        </div>

        <div class="card-body" [ngClass]="{'wrapper': isModal}">
            <form [formGroup]="form" id="formConstatacao" #f="ngForm">
                <div class="row mb-2">
                    <div class="col-md-12 mb-2">
                        <label for="titulo" class="mb-1">Título</label>
                        <input type="text" id="titulo" [attr.disabled]="visualizar ? true : null"
                            class="form-control form-control-sm" formControlName="titulo" maxlength="150"
                            placeholder="Digite o título"
                            [ngClass]="{ 'is-invalid': f.submitted && form.controls['titulo'].invalid }" />
                        <div *ngIf="f.submitted && form.controls['titulo'].invalid" class="invalid-feedback">
                            <div *ngIf="form.controls['titulo'].errors.required">Campo obrigatório</div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-2">
                        <label for="descricao" class="mb-1">Descrição</label>
                        <textarea class="form-control" rows="4" maxlength="500" name="descricao" [readonly]="visualizar"
                            required formControlName="descricao" placeholder="Digite uma descrição"
                            [ngClass]="{ 'is-invalid': f.submitted && form.controls['descricao'].invalid }">
              </textarea>
                        <div *ngIf="f.submitted && form.controls['descricao'].invalid" class="invalid-feedback">
                            <div *ngIf="form.controls['descricao'].errors.required">Campo obrigatório</div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-2">
                        <label for="tipo" class="mb-1">Tipo</label>
                        <ng-select id="tipo" [readonly]="visualizar" name="tipo" placeholder="Selecione um tipo"
                            formControlName="tipo" placeholder="Selecione um tipo"
                            [ngClass]="{ 'is-invalid': f.submitted && form.controls['tipo'].invalid }">
                            <ng-option *ngFor="let tipo of listaTipo" [value]="tipo.value">
                                {{ tipo.text }}
                            </ng-option>
                        </ng-select>
                        <div *ngIf="f.submitted && form.controls['tipo'].invalid" class="invalid-feedback">
                            <div *ngIf="form.controls['tipo'].errors.required">Campo obrigatório</div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-2">
                        <label for="criteriosInfrigidos" class="mb-1">Critérios Infringidos</label>
                        <textarea class="form-control" rows="4" maxlength="200" name="criteriosInfrigidos"
                            [readonly]="visualizar" required formControlName="criteriosInfrigidos"
                            placeholder="Digite os critérios infringidos"
                            [ngClass]="{ 'is-invalid': f.submitted && form.controls['criteriosInfrigidos'].invalid }">
                        </textarea>
                        <div *ngIf="f.submitted && form.controls['criteriosInfrigidos'].invalid"
                            class="invalid-feedback">
                            <div *ngIf="form.controls['criteriosInfrigidos'].errors.required">Campo obrigatório</div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-2">
                        <label for="situacaoEncontrada" class="mb-1">Situação Encontrada</label>
                        <textarea class="form-control" rows="4" maxlength="500" name="situacaoEncontrada"
                            [readonly]="visualizar" required formControlName="situacaoEncontrada"
                            placeholder="Digite a situação encontrada"
                            [ngClass]="{ 'is-invalid': f.submitted && form.controls['situacaoEncontrada'].invalid }">
  </textarea>
                        <div *ngIf="f.submitted && form.controls['situacaoEncontrada'].invalid"
                            class="invalid-feedback">
                            <div *ngIf="form.controls['situacaoEncontrada'].errors.required">Campo obrigatório</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-footer">
            <div class="btn-group" [hidden]="visualizar">
                <button class="btn btn-primary btn-sm mr" (click)="onSubmit()">
                    <i class="far fa-save"></i> Salvar
                </button>
            </div>
            <button type="button" class="btn btn-default btn-sm" (click)="onBack()">
                <i class="fas fa-times"></i> {{visualizar ? 'Sair' : 'Cancelar' }}
            </button>
        </div>
    </div>
</div>